import type { IconProps } from '~/components/icons/types';

export const DEFAULT_ICON_PROPS: IconProps = {
  iconColor: 'currentColor',
  size: 24,
  disabled: false,
  className: 'text-slate-900',
};
